/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FillStatus {
    EMPTY = 'EMPTY',
    PARTIAL = 'PARTIAL',
    COMPLETE = 'COMPLETE',
}
